import uploader from './uploader'
import MultipartUpload from './multipart-upload'
import util from './util'

let self = {
  _uploader: uploader,
  async uploads(uploadObject, callback) {
    return await new Promise((resolve) => {
      let files = {
        success: {},
        error: {}
      }
      let numberProcess = 0
      let processUploading = {}
      let fileUploads = []
      if (Object.keys(uploadObject).length > 0) {
        Object.entries(uploadObject).forEach(([id, object]) => {
          let defaultObject = {
            ...object
          }
          delete defaultObject.files
          processUploading[id] = {}
          Object.values(object.files).forEach((file, index) => {
            if (file instanceof File || file instanceof Blob) {
              fileUploads.push(
                Object.assign(
                  {
                    ...defaultObject
                  },
                  {
                    id,
                    index,
                    file
                  }
                )
              )
              processUploading[id][index] = 0
            }
          })
        })
      }
      let totalFile = fileUploads.length

      let timeLoop = setInterval(() => {
        for (let index = 0; index < 10; index++) {
          if (fileUploads.length > 0 && numberProcess < 10) {
            let fileUpload = fileUploads.shift()
            numberProcess++

            if (_.isFunction(callback?.beforeUpload)) {
              callback.beforeUpload(fileUpload)
            }
            this.upload(fileUpload, {
              process(progress, object) {
                processUploading[object.id][object.index] = progress
                object.uploaded = progress
                uploadObject[object.id].uploaded = Object.values(processUploading[object.id]).reduce((sum, item) => sum + item, 0) / Object.keys(processUploading[object.id]).length
                if (_.isFunction(callback?.process)) {
                  callback.process(uploadObject[object.id].uploaded, object, uploadObject)
                }
              }
            })
              .then((response) => {
                numberProcess--
                files = this._addToResponse(files, fileUpload, response, !_.isUndefined(response.fileid) ? 'success' : 'error')

                if (_.isFunction(callback?.afterUpload)) {
                  callback.afterUpload(fileUpload, response)
                }

                let numberUploaded = 0
                util.map(files.success, ({ item }) => {
                  numberUploaded += Object.keys(item.fileids).length
                })
                util.map(files.error, ({ item }) => {
                  numberUploaded += Object.keys(item.files).length
                })

                if (numberProcess == 0 && totalFile == numberUploaded) {
                  clearInterval(timeLoop)
                  if (_.isFunction(callback?.completed)) {
                    callback.completed(files)
                    resolve(files)
                  } else if (_.isFunction(callback)) {
                    callback(files)
                    resolve(files)
                  }
                }
              })
              .catch((e) => {
                console.log(e)
                files = this._addToResponse(files, fileUpload, e, 'error')
                callback.error(files)
                numberProcess--
              })
          }
        }
      }, 500)
    })
  },
  async upload(object, callback) {
    // Straight to MinIO over presigned urls when the storage service is set up for it
    if (util.options.api?.storage_direct_upload) {
      callback.process(0.1, object)
      return new MultipartUpload(object.file, {
        endpoint: util.options.api?.storage?.upload,
        token: decodeURIComponent(util.cookie.get('SF-TOKEN', false) || ''),
        extension: object.file.name.split('.').slice(-1)[0],
        onProgress: (progress) => callback.process(progress, object)
      }).start()
    }

    return await new Promise((resolve, reject) => {
      let headers = {
        'Authorization': `Bearer ${decodeURIComponent(util.cookie.get('SF-TOKEN', false) || '')}`,
        'uploader-file-extension': object.file.name.split('.').slice(-1)[0]
      }
      let uploader = new this._uploader({
        endpoint: util.options.api?.storage?.upload,
        headers: headers,
        file: object.file
      })

      callback.process(0.1, object)

      uploader.on('error', (err) => {
        reject(err)
      })

      uploader.on('progress', (progress) => {
        callback.process(progress.detail, object)
      })

      uploader.on('finish', (response) => {
        resolve(response.detail)
      })
    })
  },
  async ping(url, callback = null) {
    return new Promise((resolve, reject) => {
      fetch(`${util.options.api?.storage?.ping}/${url}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${decodeURIComponent(util.cookie.get('SF-TOKEN', false) || '')}`
        }
      })
        .then(async (res) => {
          // The storage service answers a url that is down with a 200 saying so; master-tool-file errored
          const alive = res.status === 200 ? (await res.json().catch(() => ({})))?.data?.alive !== false : res.status === 201 || res.status === 204
          if (alive) {
            if (_.isFunction(callback?.done)) callback.done(true)
            resolve(true)
          } else {
            if (_.isFunction(callback?.error)) callback.error(true)
            reject(false)
          }
        })
        .catch(() => {
          reject(false)
          if (_.isFunction(callback?.error)) callback.error(true)
        })
    })
  },
  async getProxy(uri, callback, config, args) {
    return self.proxy('get', uri, callback, config, args)
  },
  async postProxy(uri, callback, config, args) {
    return self.proxy('post', uri, callback, config, args)
  },
  async proxy(method, uri, callback, config, args) {
    config = Object.assign({}, config, {
      headers: {
        Authorization: `Bearer ${decodeURIComponent(util.cookie.get('SF-TOKEN', false) || '')}`
      }
    })
    return util[`force${util.toPascalCase(method)}`](`${util.options.api?.storage?.proxy}/${uri}`, null, null, callback, config, args)
  },
  async uploadFromUrl(uri, $el, callback, config, args) {
    config = Object.assign({}, config, {
      headers: {
        Authorization: `Bearer ${decodeURIComponent(util.cookie.get('SF-TOKEN', false) || '')}`
      }
    })
    return util.forceGet(`${util.options.api?.storage?.['upload-from-url']}/${uri}`, null, $el, callback, config, args)
  },
  _addToResponse(files, fileUpload, response, status) {
    if (!_.isObjectLike(files[status][fileUpload.id])) {
      files[status][fileUpload.id] = {
        ...fileUpload
      }
      files[status][fileUpload.id].files = {}
      files[status][fileUpload.id].fileids = {}
      delete files[status][fileUpload.id].file
    }
    files[status][fileUpload.id].files[fileUpload.index] = fileUpload.file
    files[status][fileUpload.id].fileids[fileUpload.index] = response
    return files
  }
}
export default self
